import axios from "axios";
import { auction } from "./models";
import routersName from "./routernames";
const api = new routersName().auctionqueryUsar;

export default class AutionClient {
  getItemsByPage = async () => {
    try {
      const response = await axios.get(`${api}/all`);
      return response.data.data as auction[];
    } catch (error) {
      throw new Error("Could not get taxis");
    }
  };
  getItem = async (id: any) => {
    try {
      const response = await axios.get(
        `https://chapa100.onrender.com/api/beiraBoladas/clientaution/item/${id}/ij`
      );
      return response.data.data[0];
    } catch (error) {
      throw new Error("Could not get taxis");
    }
  };
}
